/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Box, Button, Flex, Paper, Stack, Text, Title } from "@mantine/core";
import { IconClipboardList, IconPlus } from "@tabler/icons-react";
import { Avatar } from "@aws-amplify/ui-react";
import {
  FetchUserAttributesOutput,
  fetchUserAttributes,
} from "aws-amplify/auth";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { sortByUpdatedAt } from "@/utils/utils";
import { templatesByLIDAndUpdatedAt } from "@/graphql/queries";
import {
  ModelSortDirection,
  TemplatesByLIDAndUpdatedAtQuery,
  TemplatesByLIDAndUpdatedAtQueryVariables,
} from "@/API";
import SkeletonPatient from "./SkeletonPatient";

const client = generateClient();

const RecentTemplateComponent = () => {
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState<any>();
  const navigate = useNavigate();
  useEffect(() => {
    fetchTemplates();
  }, []);
  const formatTimeTemplate = (time: string) => {
    return moment(time).format("MMMM DD");
  };
  async function fetchTemplates() {
    setLoading(true);
    try {
      const userAttr: FetchUserAttributesOutput = await fetchUserAttributes();
      const templatesQueryInput: TemplatesByLIDAndUpdatedAtQueryVariables = {
        lID: userAttr["custom:location"]!,
        sortDirection: ModelSortDirection.DESC,
        filter: {
          _deleted: { ne: true },
          archived: { ne: true },
        },
      };
      const templatesData: any = await client.graphql<
        GraphQLQuery<TemplatesByLIDAndUpdatedAtQuery>
      >({ query: templatesByLIDAndUpdatedAt, variables: templatesQueryInput });
      const templatesList =
        templatesData.data.templatesByLIDAndUpdatedAt!.items;
      const templateResult = templatesList.sort(sortByUpdatedAt);
      if (templateResult?.length > 5) {
        templateResult.length = 5;
      }
      setTemplates(templateResult);
    } catch (err) {
      console.warn(err);
    }
    setLoading(false);
  }
  return (
    <Paper withBorder shadow="sm" px={30} py={28}>
      <Title size={"20"} mb={36} c={"#2D2D2D"}>
        Recent Templates
      </Title>
      {loading && (
        <Stack>
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
          <SkeletonPatient />
        </Stack>
      )}
      {!loading && (
        <Stack>
          {templates?.map((template: any) => (
            <Flex flex={1} key={template.id}>
              <Avatar borderRadius={"xl"}>
                <IconClipboardList color="#666666" />
              </Avatar>
              <Flex ml={10} direction={"column"}>
                <Text
                  fw={"600"}
                  fz={14}
                  c={"#003554"}
                  lh={1}
                  td={"underline"}
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(`/template-detail/${template.id}`, {
                      state: template,
                    })
                  }
                >
                  {template.name}
                </Text>
                <Text
                  size={"12px"}
                  fw={600}
                  fs={"italic"}
                  mt={8}
                  lh={1}
                  c={"#666666"}
                >
                  {`Last updated: ${formatTimeTemplate(template.updatedAt)}`}
                </Text>
              </Flex>
            </Flex>
          ))}
          <Button
            radius={"lg"}
            w={200}
            p={0}
            justify="flex-start"
            onClick={() => {
              navigate("/templates", { state: { addTemplate: true } });
            }}
          >
            <Box px={8}>
              <IconPlus />
            </Box>
            <Text lh={1} fz={14} fw={600}>
              Create New Template
            </Text>
          </Button>
        </Stack>
      )}
    </Paper>
  );
};

export default RecentTemplateComponent;
